import thunk from "redux-thunk" 
import { createStore, combineReducers, applyMiddleware } from 'redux';
import userReducer from './reducers/userReducer';
import invoiceFilesReducers from './reducers/invoiceFilesReducers';
import temporalPricesReducer from './reducers/temporalPricesReducer';

const rootReducer = combineReducers({
  user: userReducer,
  invoiceFiles: invoiceFilesReducers,
  products_list: temporalPricesReducer,
});

const store = createStore(rootReducer,applyMiddleware(thunk));

export default store;